import { APP_INFO } from '../app-info';
import type { Zdrowie } from '../api';

/**
 * Stopka z metadanymi wydania. Wersja pochodzi z scripts/app.ts (ten sam plik czyta
 * API), więc rozjazd „co właściwie stoi na serwerze" jest widoczny od razu.
 */
export function Footer({ zdrowie }: { zdrowie: Zdrowie | null }) {
  const rozjazd = zdrowie !== null && zdrowie.wersja !== APP_INFO.version;

  return (
    <footer className="border-t border-n-100 px-18 py-14">
      <div className="mx-auto flex max-w-[960px] flex-wrap items-center gap-x-18 gap-y-5">
        <span className="t-mono-data text-n-500">
          {APP_INFO.name} {APP_INFO.version}
        </span>
        <span className="t-mono-data text-n-500">{APP_INFO.updatedAt}</span>
        {zdrowie && (
          <span className="t-mono-data text-n-500">
            API {zdrowie.wersja} · baza {zdrowie.baza}
          </span>
        )}
        {rozjazd && (
          <span className="t-small text-status-failure">
            Wersja interfejsu i API są różne — odśwież stronę.
          </span>
        )}
        <span className="t-small ml-auto text-n-500">{APP_INFO.copyright}</span>
      </div>
    </footer>
  );
}
